import { RegistrationStep, ServerOnlyRegistrationStep } from '@lessonup/typescript-core/services';

export function isClientOnlyRegistrationStep(
  step: RegistrationStep
): step is Exclude<RegistrationStep, ServerOnlyRegistrationStep> {
  return step !== 'verify-email';
}
